import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../../axiosInstance';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import GenericCard from '../../../common/GenericCard';
import CommonModal from '../../../common/CommonModal';
import TextField from 'apollo-react/components/TextField';

const NewRequests = () => {
  const [t] = useTranslation();
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [showFormNameModal, setShowFormNameModal] = useState(false);
  const [selectedRequestId, setSelectedRequestId] = useState(null);
  const [formName, setFormName] = useState('');
  const [formNameError, setFormNameError] = useState('');

  useEffect(() => {
    const fetchNewRequests = async () => {
      const response = await axiosInstance
        .get('/api/requests-progress/user/requests/new')
        .catch((err) => {
          console.log(err);
        });
      setData(response?.data);
    };
    fetchNewRequests();
  }, []);

  const handleApply = (id) => {
    setSelectedRequestId(id);
    setShowFormNameModal(true);
    setFormName('');
    setFormNameError('');
  };

  const handleConfirmFormName = () => {
    const trimmed = formName.trim();
    if (!trimmed) {
      setFormNameError('Form name is required');
      return;
    }

    setShowFormNameModal(false);
    navigate(
      `/customer/requests/new-requests/view/${selectedRequestId}?request_name=${encodeURIComponent(trimmed)}`
    );
  };

  const handleCancelFormName = () => {
    setShowFormNameModal(false);
    setSelectedRequestId(null);
    setFormName('');
    setFormNameError('');
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 32,
          marginTop: 40,
        }}
      >
        {' '}
        {data?.map((item) => (
          <GenericCard
            key={item.id}
            label={item.name}
            description={
              item.description && item.description.length > 150
                ? `${item.description.substring(0, 150)}...`
                : item.description
            }
            buttonLabel={t('Apply')}
            onButtonClick={() => handleApply(item.id)}
            imageId={item?.workflow_image_id}
          />
        ))}
      </div>
      <CommonModal
        open={showFormNameModal}
        onClose={handleCancelFormName}
        title={t('Request Name')}
        size="small"
        buttonProps={[
          {
            label: t('Cancel'),
            onClick: handleCancelFormName,
          },
          {
            label: t('Confirm'),
            onClick: handleConfirmFormName,
            variant: 'primary',
          },
        ]}
      >
        <TextField
          label={t('Please enter a request name')}
          placeholder={t('Ex: Request type - Product name')}
          value={formName}
          onChange={(e) => {
            setFormName(e.target.value);
            setFormNameError('');
          }}
          error={Boolean(formNameError)}
          helperText={formNameError}
          fullWidth
          style={{ width: '400px' }}
        />
      </CommonModal>
    </>
  );
};

export default NewRequests;
